import { gql } from '@apollo/client';

export default gql`
  mutation validate ($model: String!, $field: String!, $value: String!, $defaultValue: String) {
    validate (model: $model, field: $field, value: $value, defaultValue: $defaultValue)
  }
`